import React, { useEffect } from 'react'
import * as yup from 'yup'
import { Grid } from '@mui/material'
import { Formik, Form } from 'formik'

import {
  DialogButtons,
  FormikField,
  SelectEvent,
  isObjectEmpty,
  useStepper,
} from 'shared'

const ForgotPasswordStep = ({ onMount }: { onMount: () => void }) => {
  const { goToNextStep, goToPrevStep } = useStepper()

  useEffect(() => {
    onMount()
  }, [])

  return (
    <Grid>
      <Formik
        onSubmit={goToNextStep}
        validationSchema={yup.object().shape({
          email: yup.string().email(),
        })}
        initialValues={{
          email: '',
        }}
      >
        {({ values, setFieldValue, errors, dirty }) => {
          return (
            <Form>
              <FormikField
                name="email"
                value={values.email}
                label="Email"
                placeholder="Enter email address"
                onChange={(e: SelectEvent) =>
                  setFieldValue('email', e.target.value)
                }
              />
              <DialogButtons
                onCancel={goToPrevStep}
                submitTitle="Request a reset link"
                isSubmitDisabled={!dirty || !isObjectEmpty(errors)}
              />
            </Form>
          )
        }}
      </Formik>
    </Grid>
  )
}

export default ForgotPasswordStep
